import {
  findIndex, each, uniq, map, cloneDeep, min,
} from 'lodash';
import { uuid } from 'vue-uuid';
import types from './mutationTypes';

const formatOutcomes = (outcomes) => {
  let outcomesCopy = outcomes;
  const outcomesModel = [];
  if (outcomesCopy.constructor !== Array) {
    outcomesCopy = String(outcomesCopy).split(',');
  }
  each(outcomesCopy, (outcome) => {
    const outcomeObject = {};
    outcomeObject.title = outcome;
    outcomesModel.push(outcomeObject);
  });

  return outcomesModel;
};

const calcCombinations = (n, k) => Math.factorial(n) / (Math.factorial(k) * Math.factorial(n - k));

const getCombinations = (bet) => {
  if (bet.product === 'LuckySix') {
    const n = 6;
    for (let i = 7; i <= 10; i += 1) {
      if (bet.id === i - n) {
        return calcCombinations(i, n);
      }
    }
  } else if (bet.product === 'LuckyX') {
    if (bet.system) {
      const systemType = bet.system.split('/')[0];
      const systemLen = bet.system.split('/')[1];
      return calcCombinations(systemLen, systemType);
    }
  }
  return 1;
};

const rebetGroups = (bets) => {
  let betGroups = [];
  const obj = {};
  if (bets.length) {
    const futureRounds = uniq(map(bets, 'eventId'));
    if (bets.length > 1 && futureRounds.length > 1) {
      const result = bets.filter((a) => {
        const key = `${a.value} | ${a.type}`;
        if (!obj[key]) {
          obj[key] = true;
          return true;
        }
        return false;
      }, Object.create(null));

      each(result, (bet) => {
        betGroups.push(bet);
      });
    } else {
      betGroups = bets;
    }
  }
  return betGroups;
};

const rebetFutureRounds = bets => uniq(map(bets, 'eventId'));

let tempPayments = [];

export default {
  [types.SET_CONFIG](state, config) {
    state.betslipConfig = config;
    state.futureBets = state.betslipConfig.meta.futureBets;
    state.minPayment = state.betslipConfig.meta.minPayment;
    state.totalPayment = state.betslipConfig.meta.minPayment;
    state.minStakePerBet = state.betslipConfig.meta.minStakePerBet;
    state.amountToSplit = state.betslipConfig.meta.amountToSplit;
  },
  [types.ADD_BET](state, data) {
    const { bets } = state.ticket;
    if (data.bets && data.bets.length) {
      if (data.rebet) {
        each(data.bets, (betItem) => {
          const bet = betItem;
          if (bet.value.constructor === Array) {
            bet.value = bet.value.join(',');
          }
        });
        const betGroups = rebetGroups(data.bets);
        state.futureBets = rebetFutureRounds(data.bets).length;
        each(betGroups, (item) => {
          const bet = {};
          bet.minStake = 0;
          bet.stake = item.amount || state.betslipConfig.meta.minStake;
          bet.payment = item.amount * state.futureBets || state.betslipConfig.meta.minStake;
          bet.title = formatOutcomes(item.outcome.title);
          bet.subtitle = item.typeValue;
          bet.product = data.product;
          bet.rebet = data.rebet;
          bet.value = item.value;
          bet.type = item.category;
          bet.id = item.type;
          bet.system = item.system ? `${item.system}/${item.outcome.value.length}` : null;
          bet.rounds = state.futureBets;
          bet.outcomes = [];
          bet.combinations = getCombinations(bet) || 1;
          if (bet.combinations > 1) {
            const minCombAmount = bet.combinations * state.rules.minCombBetAmount.value;
            const minBetAmount = state.rules.minBetAmount.value;
            bet.minPayment = minCombAmount < minBetAmount ? minBetAmount : minCombAmount;
          } else {
            bet.minPayment = state.rules.minBetAmount.value;
          }
          bets.push(bet);
        });
      }
    } else {
      if (data.uuid) {
        const index = findIndex(bets, o => o.uuid === data.uuid);
        bets.splice(index, 1, data);
      } else {
        const bet = cloneDeep(data);
        bets.push(bet);
      }
    }

    state.minPayment = 0;
    each(bets, (betItem) => {
      state.minPayment += betItem.minPayment * state.futureBets;
      if (betItem.rebet) {
        if (state.totalPayment <= data.payin) {
          state.totalPayment = data.payin;
        } else {
          state.totalPayment += betItem.payment;
        }
      } else {
        state.totalPayment = state.minPayment;
      }
    });

    state.totalStakeChanged = false;
    if (state.totalStakeChanged) state.totalStake = 0;
  },
  [types.UPDATE_TICKET_ROUND_INFO](state) {
    state.roundInfo = state.futureBets > 1 ? `${state.round} - ${((state.round + state.futureBets) - 1)}` : state.round;
  },
  [types.REMOVE_BET](state, bet) {
    const index = findIndex(state.ticket.bets, bet);
    state.ticket.bets.splice(index, 1);
    if (!state.ticket.bets.length) state.editMode = false;
  },
  [types.EMPTY_BETSLIP](state) {
    state.ticket.bets.splice(0, state.ticket.bets.length);
    state.futureBets = state.betslipConfig.meta.futureBets;
    state.totalStake = state.betslipConfig.meta.minStake;
    state.minStake = state.betslipConfig.meta.minStake;
    state.minPayment = state.betslipConfig.meta.minPayment;
    state.totalPayment = state.betslipConfig.meta.minPayment;
    state.minStakePerBet = state.betslipConfig.meta.minStakePerBet;
    state.amountToSplit = state.betslipConfig.meta.amountToSplit;
    state.ticketUnpayable = false;
    state.totalStakeChanged = false;
  },


  [types.SET_BET_MIN_PAYMENT](state) {
    const { bets } = state.ticket;
    state.minPayment = 0;
    if (!bets.length) {
      state.minPayment = min(tempPayments);
    }
    each(bets, (betItem) => {
      const bet = betItem;
      bet.payment = bet.minPayment * state.futureBets;
      if (bet.payment < bet.minPayment) bet.payment = bet.minPayment;
      state.minPayment += bet.payment;
      if (!state.totalStakeChanged && !bet.rebet) {
        state.totalPayment = state.minPayment;
      }
      if (state.totalPayment < state.minPayment && state.futureBets > 1) {
        state.totalPayment = state.minPayment;
      }
    });
  },
  [types.SET_TOTAL_PAYMENT](state, value) {
    const manualPayment = typeof (value) !== 'number';
    const { bets } = state.ticket;
    state.totalPayment = Number(value);
    state.totalStakeChanged = true;
    if (bets.length) {
      if (state.totalPayment < state.minPayment) {
        state.totalPayment = ((state.minPayment * 1000) / 1000);
      }
    } else {
      if (!manualPayment) {
        state.minPayment = state.totalPayment;
        tempPayments = [];
        tempPayments.push(state.minPayment);
      } else {
        if (state.totalPayment <= state.minPayment) {
          state.totalPayment = state.minPayment;
        }
      }
    }
    if (state.totalPayment > state.rules.maxBetAmount.value) {
      state.payinForbidden = true;
    } else {
      state.payinForbidden = false;
    }
    if (state.totalPayment > state.player.balance.balanceAmt) {
      state.ticketUnpayable = true;
    } else {
      state.ticketUnpayable = false;
    }
  },
  [types.SPLIT_PAYMENT_PER_BET](state) {
    const { bets } = state.ticket;
    const { totalPayment, minPayment } = state;
    let { paymentToSplit } = state;
    paymentToSplit = totalPayment > minPayment
      ? Number(totalPayment - minPayment) / bets.length : 0;
    for (let i = 0; i < bets.length; i += 1) {
      const bet = bets[i];
      if (paymentToSplit > 0) {
        if (bets.length > 1) {
          bet.payment = bet.minPayment * state.futureBets + Math.floor(paymentToSplit * 100) / 100;
        } else {
          bet.payment = Number(totalPayment);
          bet.stake = '';
        }
      } else {
        bet.payment = bet.minPayment * state.futureBets;
      }
      if (bet.payment / state.futureBets > state.rules.maxBetAmount.value) {
        state.payinForbidden = true;
      } else {
        state.payinForbidden = false;
      }
    }
  },


  [types.SET_MIN_TOTAL_STAKE](state) {
    const { bets } = state.ticket;
    if (bets.length) {
      if (!state.totalStakeChanged) {
        state.totalStake = 0;
      }
      // state.minStake = 0;
      for (let i = 0; i < bets.length; i += 1) {
        const bet = bets[i];
        if (bet.combinations > 1) {
          bet.minStake = bet.combinations * state.rules.minCombBetAmount.value;
        } else {
          bet.minStake = state.rules.minBetAmount.value;
        }

        if (!state.totalStakeChanged) {
          state.totalStake += bet.stake;
        }
      }
    }

    if ((state.totalStakeChanged && state.futureBets > 1 && state.totalStake < state.minStake)
      || (state.totalStakeChanged && state.futureBets === 1 && state.totalStake < state.minStake)) {
      state.totalStake = state.minStake;
    }

    if (state.totalStake < state.minStake) {
      state.totalStake = state.minStake;
    }
  },
  [types.SET_TOTAL_STAKE](state, stake) {
    state.totalStakeChanged = true;
    state.totalStake = 0;
    let newStake = 0;
    const { bets } = state.ticket;

    if (!bets.length) {
      state.totalStake = state.betslipConfig.meta.minStake;
      return;
    }

    if (!stake && bets.length) {
      for (let i = 0; i < bets.length; i += 1) {
        const bet = bets[i];
        newStake += (bet.minStake * bet.rounds);
      }
    } else {
      newStake = stake;
    }

    state.totalStake = ((newStake * 1000) / 1000);

    if (state.totalStake < state.minStake) {
      state.totalStake = ((state.minStake * 1000) / 1000);
    }

    if (state.totalStake > state.balanceValue.balanceAmt) {
      state.ticketUnpayable = true;
    } else {
      state.ticketUnpayable = false;
    }
  },
  [types.SPLIT_STAKE_PER_BET](state) {
    const { bets } = state.ticket;
    const { totalStake, minStake } = state;
    let { amountToSplit } = state;
    amountToSplit = Number(totalStake - minStake) / bets.length;

    for (let i = 0; i < bets.length; i += 1) {
      const bet = bets[i];
      if (state.totalStakeChanged && state.totalStake > state.minStake) {
        bet.stake = bet.minStake * state.futureBets + Math.floor(amountToSplit * 100) / 100;
      } else if (state.totalStakeChanged && state.totalStake === state.minStake) {
        bet.stake = bet.minStake;
      } else {
        bet.stake *= state.futureBets;
      }

      if (bet.stake / state.futureBets > state.rules.maxBetAmount.value) {
        state.payinForbidden = true;
      } else {
        state.payinForbidden = false;
      }
    }
  },
  [types.SET_FUTURE_BETS](state, futureBets) {
    const { maxFutureBets } = state.betslipConfig.meta;

    if (futureBets && (futureBets >= 1 && futureBets <= maxFutureBets)) {
      state.futureBets = futureBets;
    }

    if (futureBets > maxFutureBets) {
      state.futureBets = 0;
      state.futureBets = maxFutureBets;
    }

    // Fix this shit
    if (futureBets === 0) {
      state.futureBets = 0;
      state.futureBets = 1;
    }

    if (state.futureBets) {
      const increment = Number(state.futureBets);
      const { bets } = state.ticket;
      state.minPayment = 0;
      // state.totalPayment = 0;
      for (let i = 0; i < bets.length; i += 1) {
        const bet = bets[i];
        bet.rounds = increment;
        state.minPayment += bet.minPayment * state.futureBets;
      }
    }
  },
  [types.SHOW_HIDE_BETSLIP](state) {
    state.showBetslip = !state.showBetslip;
  },
  [types.TOGGLE_PAYIN_ACTION](state, payin) {
    state.payinForbidden = payin;
  },
  [types.SET_TICKET_RULES](state, rules) {
    state.ticketRules = rules;
  },
  [types.SET_BALANCE_VALUE](state, value) {
    state.balanceValue = value;
  },
  [types.GO_TO_DETAIL_BET](state, bet) {
    state.selectedBet = bet;
    state.selectedBet.uuid = uuid.v4();
    state.editMode = !state.editMode;
  },
  [types.RESET_SELECTED_BET](state) {
    state.selectedBet = {};
    state.editMode = false;
  },
  [types.CHECK_BALANCE](state) {
    state.ticketUnpayable = state.player.balance.balanceAmt < state.totalPayment;
  },
};
